var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioWithoutLyrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_45",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audio",
    transform: "translate(-328.5 -175.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(342 186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13.5, -10.5)",
    filter: "url(#Rectangle_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 61,
    height: 61,
    rx: 30.5,
    transform: "translate(13.5 10.5)",
    fill: "#fe8901"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "music",
    transform: "translate(-114.059 -252.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M556.9,460.157a1.319,1.319,0,0,1,1.317,1.318V466.8L539,473.551V467.3a1.319,1.319,0,0,1,.88-1.243l16.581-5.827A1.314,1.314,0,0,1,556.9,460.157Zm-.437,5.4v-3.464l-15.707,5.52v3.464Z",
    transform: "translate(-58.35 -5.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    d: "M3.672-1A5.027,5.027,0,0,1,6.922.145,3.817,3.817,0,0,1,8.345,3.081,3.817,3.817,0,0,1,6.922,6.016,5.027,5.027,0,0,1,3.672,7.162,5.027,5.027,0,0,1,.423,6.016,3.817,3.817,0,0,1-1,3.081,3.817,3.817,0,0,1,.423.145,5.027,5.027,0,0,1,3.672-1Zm0,6.408A2.677,2.677,0,0,0,6.591,3.081,2.677,2.677,0,0,0,3.672.754,2.677,2.677,0,0,0,.754,3.081,2.677,2.677,0,0,0,3.672,5.408Z",
    transform: "translate(474.059 477.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    d: "M4.242-1A5.65,5.65,0,0,1,7.895.286a4.261,4.261,0,0,1,1.59,3.276,4.261,4.261,0,0,1-1.59,3.276A5.65,5.65,0,0,1,4.242,8.124,5.65,5.65,0,0,1,.59,6.838,4.261,4.261,0,0,1-1,3.562,4.261,4.261,0,0,1,.59.286,5.65,5.65,0,0,1,4.242-1Zm0,7.37c1.923,0,3.488-1.26,3.488-2.808S6.166.754,4.242.754.754,2.014.754,3.562,2.319,6.37,4.242,6.37Z",
    transform: "translate(490.381 470.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M-.123,14.087A.877.877,0,0,1-1,13.21V-.123A.877.877,0,0,1-.123-1a.877.877,0,0,1,.877.877V13.21A.877.877,0,0,1-.123,14.087Z",
    transform: "translate(481.65 467.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M623.23,499.911a.877.877,0,0,1-.877-.877V485.7a.877.877,0,1,1,1.754,0v13.333A.877.877,0,0,1,623.23,499.911Z",
    transform: "translate(-124.242 -24.71)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWithoutLyrics);
export default __webpack_public_path__ + "static/media/audioWithoutLyrics.4e12a86131f9bc16cfebb5c3d0d181c1.svg";
export { ForwardRef as ReactComponent };